import { urlService } from '@whiz-cart/ui-shared/url/url.service';

/** Get the currently selected `storeGuid`. `isGlobal` is `true` when no store is selected. */
export function useStoreGuid(): { storeGuid: string | undefined; isGlobal: boolean };
/** Get the currently selected `storeGuid`, or `fallback` if none is selected. `isGlobal` is `true` when no store is selected. */
export function useStoreGuid(fallback: string): { storeGuid: string; isGlobal: boolean };
export function useStoreGuid(fallback?: string): { storeGuid: string | undefined; isGlobal: boolean } {
    return urlService.state.useStore((state) => ({
        storeGuid: state.params.storeGuid ?? fallback,
        isGlobal: typeof state.params.storeGuid === 'undefined',
    }));
}
